<template>
  <div class="c-app" :class="{ 'c-dark-theme': $store.state.darkMode }">
    <TheSidebar/>
    <!--    <TheAside/>-->
    <CWrapper ref="navWrapper">
      <div class="fixed-notification"
           :style="isShowNotificationEmergency ? 'background-color:red' : 'background-color:#2d8be0'"
           id="notificationFixed">
        <marquee behavior="scroll" direction="left" v-if="isShowNotificationEmergency">
          Địa bàn của bạn đang có bản tin vừa được đặt khẩn cấp từ người dùng cấp trên -
          <b>{{ notificationEmergency.locationName }}</b>.
          Bản tin sẽ kết thúc vào lúc <b>{{ notificationEmergency.times }}</b>, trên các thiết bị :
          <b>
            <template v-for="each in viewDevice(notificationEmergency.devices)">
              {{ each + ", " }}
            </template>
            <template v-if="notificationEmergency.devices.length > maxDisplayDeviceTable">...</template>
          </b>
          nếu người dùng đang phát trực tiếp, vui lòng kết thúc nếu không cần thiết để bản tin không bị gián đoạn!
        </marquee>
        <marquee v-else>
          Hôm nay, {{ showNotification }}. Chúc người dùng có 1 ngày làm việc hiệu quả và thành
          công.
          Nếu có bất cứ vấn đề liên quan đến hệ thống, vui lòng liên hệ theo số hotline: <b>0983231999</b>.
        </marquee>
      </div>
      <TheHeader/>
      <div class="c-body" id="headerNav">
        <main class="c-main mt-1">
          <CContainer fluid>
            <transition name="fade">
              <router-view></router-view>
            </transition>
          </CContainer>
        </main>
        <TheFooter/>
      </div>
    </CWrapper>
  </div>
</template>

<script>
import TheSidebar from './TheSidebar'
import TheHeader from './TheHeader'
import TheFooter from './TheFooter'
import TheAside from './TheAside'
import {authAutoLogout, authLogout} from "@/security/index";
import {ACCESS_TOKEN_EXPIRED, NOTIFICATION_EMERGENCY} from '../constant'

export default {
  name: 'TheContainer',
  components: {
    TheSidebar,
    TheHeader,
    TheFooter,
    TheAside
  },
  data() {
    return {
      intervalAutoLogout: null,
      intervalTimes: null,
      intervalHiddenNotification: null,
      showNotification: this.$helper.formatDateDetail(new Date()),
      isShowNotificationEmergency: false,
      notificationEmergency: null,
      maxDisplayDeviceTable: 5,
    }
  },
  mounted() {
    this.scrollNotification();
    this.countAutoLogout();
    this.connectWebSocket();
    this.countdownTimes();

    if (localStorage.getItem(NOTIFICATION_EMERGENCY) != null) {
      this.isShowNotificationEmergency = true;
      this.notificationEmergency = JSON.parse(localStorage.getItem(NOTIFICATION_EMERGENCY));
    }

  },
  methods: {
    countdownShowNotification() {
      this.intervalHiddenNotification = setInterval(() => {
        var notificationEmergency = JSON.parse(localStorage.getItem(NOTIFICATION_EMERGENCY));
        if (notificationEmergency != null && notificationEmergency.timeExpired != null) {
          if (new Date(notificationEmergency.timeExpired) <= new Date()) {
            this.isShowNotificationEmergency = false;
            localStorage.removeItem(NOTIFICATION_EMERGENCY);
          }
        } else {
          this.isShowNotificationEmergency = false;
          clearInterval(this.intervalHiddenNotification);
        }
      }, 1000);
    },
    countdownTimes() {
      this.intervalTimes = setInterval(() => {
        this.showNotification = this.$helper.formatDateDetail(new Date());
      }, 1000);
    },
    viewDevice(item) {
      if (!item) {
        return [];
      }
      if (item.length <= this.maxDisplayDeviceTable) {
        return item;
      }
      return item.slice(0, this.maxDisplayDeviceTable);
    },
    scrollNotification() {
      window.addEventListener('scroll', () => {
        var doc = document.getElementById('headerNav');
        var top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
        if (top <= 10) {
          document.getElementById("notificationFixed").style.position = '';
        } else {
          document.getElementById("notificationFixed").style.position = 'fixed';
        }
      });
    },
    countAutoLogout() {
      let that = this;
      let exp_token = localStorage.getItem(ACCESS_TOKEN_EXPIRED)
      if (exp_token) {
        let expiredTime = new Date(exp_token * 1)
        this.intervalAutoLogout = setInterval(() => {
          let time = new Date();
          if (time >= expiredTime) {
            authAutoLogout();
          }
        }, 1000)
      }
    },
    connectWebSocket: function () {
      let that = this
      that.$connectSocket(successCallback => {
        if (successCallback) {
          successCallback.subscribe("/user/notification", notification => {
            that.$store.commit('setDataNotification', notification)
          });
          that.$sendMessageSocket("/app/server.message.notification", null, {})

          successCallback.subscribe("/user/notification-emergency", notification => {
            if (notification.body !== '') {
              this.isShowNotificationEmergency = true;
              let data = JSON.parse(notification.body)
              this.notificationEmergency = {
                devices: data.devices,
                locationName: data.locationName,
                times: data.endTimes,
                timeExpired: this.$helper.plusDateTime(5, 'm')
              }
              localStorage.setItem(NOTIFICATION_EMERGENCY, JSON.stringify(this.notificationEmergency));
              this.countdownShowNotification();
            } else {
              localStorage.removeItem(NOTIFICATION_EMERGENCY);
              clearInterval(this.intervalHiddenNotification);
            }
          })
          that.$sendMessageSocket("/app/server.message.notification-emergency", null, {})

          successCallback.subscribe("/notification", notification => {
            that.$store.commit('setDataNotification', notification)
          });
          successCallback.subscribe("/ping", ping => {
          });
          successCallback.subscribe("/user/devices/live", liveMessage => {
            let data = JSON.parse(liveMessage.body)
            that.$store.commit('setDataLiveStreamMessage', data)
          });
          successCallback.subscribe("/user/enable-user", user => {
            let data = JSON.parse(user.body)
            that.$store.commit('setBlockUser', data.data.blocked)
          });
          successCallback.subscribe("/user/at-cmd", atCmd => {
            let data = JSON.parse(atCmd.body)
            that.$store.commit('set', ['atCmd', data])
          });
        }
      }, errorCallback => {
        console.log(errorCallback)
      })
    },
  },
  destroyed() {
    clearInterval(this.intervalAutoLogout);
    clearInterval(this.intervalTimes);
  },
  computed: {},
  watch: {
    '$store.state.reconnectSocket': function (value) {
      if (value) {
        this.connectWebSocket();
      }
      this.$store.commit("set", ["reconnectSocket", false])
    },
  }
}
</script>

<style scoped>
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
